import axios from "axios";
import React, { useEffect, useState } from "react";
import TableHeader from "../Utility/TableHeader";
import { Tooltip } from "react-tooltip";
import { EyeIcon, PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import { Pagination } from "../../helper/HelperTwo";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function LeadEmployeesList({
  paginationCustomerData,
  fetchEmployeesData,
  setSaveBtn,
  setContact_details,
  setCurrentPage,
  setIsEditing,
  setEditIdCryptForEmployees,
  setEmployeesDatas,
  setEmployeeWork,
  paginationEmployeeData,
  setOpenDialogBoxForEmployees,
  setLoading,
  id_crypt,
  showForm,
  filterParams,
}) {
  const navigate = useNavigate();

  const headers = ["S No", "Name", "Email", "Phone", "Action"];
  const userForView = JSON.parse(localStorage.getItem("user"));
  const employeePermissionForView =
    userForView?.employee_role_based_access?.some(
      (access) => access.label_id == 5 && access.label_value != 0
    );

  const userForDelete = JSON.parse(localStorage.getItem("user"));
  const employeePermissionForDelete =
    userForDelete?.employee_role_based_access?.some(
      (access) => access.label_id == 4 && access.label_value != 0
    );

  const handleViewForEmployee = async (id_crypt) => {
    setIsEditing(true);
    setOpenDialogBoxForEmployees(true);
    setEditIdCryptForEmployees(id_crypt);
    setSaveBtn("update");
    try {
      const response = await axios.get(
        `public/api/admin/employees/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setEmployeesDatas((prev) => ({
        ...prev,
        name: response.data.employee.name,
        employee_phone: response.data.employee.employee_phone,
        date_of_birth: response.data.employee.date_of_birth,
        file_name: response.data.employee.file_name,
        image_name: response.data.employee.image_name,
        contact_person_name: response.data.employee.contact_person_name,
        educational_qualification:
          response.data.employee.educational_qualification,
        company_name: response.data.employee.company_name,
        years: response.data.employee.years,
        contact_person_phone: response.data.employee.contact_person_phone,
        address_1: response.data.employee.address_1,
        address_2: response.data.employee.address_2,
        city: response.data.employee.city,
        state: response.data.employee.state,
        pincode: response.data.employee.pincode,
        official_number:
          response.data.employee?.employeeorganizationalinfo?.official_number ||
          "",
        official_email:
          response.data.employee?.employeeorganizationalinfo?.official_email ||
          "",
        password:
          response.data.employee?.employeeorganizationalinfo?.password || "",
        date_of_joining:
          response.data.employee?.employeeorganizationalinfo?.date_of_joining ||
          "",
        aadhar_number:
          response.data.employee?.employeeuniqueinfo?.aadhar_number,
        pan_number: response.data.employee?.employeeuniqueinfo?.pan_number,
        uan_number: response.data.employee?.employeeuniqueinfo?.uan_number,
        epf_number: response.data.employee?.employeeuniqueinfo?.epf_number,
        esi_number: response.data.employee?.employeeuniqueinfo?.esi_number,
        community: response.data.employee?.employeeuniqueinfo?.community,
      }));

      const employeeworkdetails =
        response.data.employee?.employeeworkdetails || [];

      console.log(employeeworkdetails, "gruu");

      setEmployeeWork(
        employeeworkdetails.map((emp) => ({
          educational_qualification: emp.educational_qualification || "",
          company_name: emp.company_name || "",
          years: emp.years || "",
        }))
      );
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  useEffect(() => {
    if (showForm && id_crypt) {
      handleViewForEmployee(id_crypt);
    }
  }, [showForm, id_crypt]);

  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);
      setCurrentPage(newPage);
      fetchEmployeesData(newPage, filterParams);
    }
  };

  const navigateForEmployeeWorks = (id_crypt) => {
    navigate(`/crm/employee_work_related`, {
      state: { id_crypt },
    });
  };

  return (
    <>
      <div className="grid md:grid-cols-1 gap-4">
        <div className="overflow-x-auto">
          <table className="min-w-full max-w-full divide-y divide-gray-300 mt-8">
            <TableHeader headers={headers} />
            <tbody className="divide-y divide-gray-200 bg-white">
              {paginationEmployeeData.data?.map((employee, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {paginationEmployeeData.from + index}
                  </td>
                  <td
                    className="py-4 px-4 text-center text-blue-600 text-base font-normal cursor-pointer whitespace-nowrap"
                    onClick={() => navigateForEmployeeWorks(employee.id_crypt)}
                  >
                    {employee.name}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {employee.employeeorganizationalinfo?.official_email}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {employee.employeeorganizationalinfo?.official_number}
                  </td>

                  <td className="flex space-x-2 items-center justify-center py-4 px-4 text-center text-sm text-gray-500 whitespace-nowrap">
                    {employeePermissionForView && (
                      <span
                        className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                        onClick={() => handleViewForEmployee(employee.id_crypt)}
                      >
                        <EyeIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-view"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          View
                        </Tooltip>
                      </span>
                    )}
                    {employeePermissionForDelete && (
                      <DeleteConfirmation
                        id_crypt={employee.id_crypt}
                        apiType="employee"
                        fetchClientData={fetchEmployeesData}
                        setLoading={setLoading}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {paginationEmployeeData && (
          <Pagination
            links={paginationEmployeeData.links}
            currentPage={paginationEmployeeData.current_page}
            totalResults={paginationEmployeeData.total}
            from={paginationEmployeeData.from}
            to={paginationEmployeeData.to}
            lastPage={paginationEmployeeData.last_page}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}

export default LeadEmployeesList;
